import { format } from 'date-fns'
import { Calendar } from 'lucide-react'

import { Card, CardContent } from '@/shared/ui/card'
import { DatePicker } from '@/shared/ui/date-picker'
import { Input } from '@/shared/ui/input'
import { type HotelReservation } from '@monorepo/functions/src/types/reservations'

interface DatesCardProps {
    reservation: HotelReservation
    onDatesChange: (dates: {
        checkInDate?: string
        checkInTime?: string
        checkOutDate?: string
        checkOutTime?: string
    }) => void
}

export function DatesCard({ reservation, onDatesChange }: DatesCardProps) {
    return (
        <Card className='w-full pt-6'>
            <CardContent>
                <div className='space-y-4'>
                    <div className='flex items-center justify-between'>
                        <span className='flex items-center gap-2'>
                            <Calendar className='h-4 w-4' />
                            Check-in:
                        </span>
                        <div className='flex items-center justify-end gap-2'>
                            <DatePicker
                                date={new Date(reservation.checkInDate)}
                                onSelect={date => {
                                    if (!date) return
                                    return onDatesChange({ checkInDate: format(date, 'yyyy-MM-dd') })
                                }}
                            />
                            <Input
                                type='time'
                                value={reservation.checkInTime}
                                onChange={e => onDatesChange({ checkInTime: e.target.value })}
                                className='w-24'
                            />
                        </div>
                    </div>
                    <div className='flex items-center justify-between'>
                        <span className='flex items-center gap-2'>
                            <Calendar className='h-4 w-4' />
                            Check-out:
                        </span>
                        <div className='flex items-center justify-end gap-2'>
                            <DatePicker
                                date={new Date(reservation.checkOutDate)}
                                onSelect={date => {
                                    if (!date) return
                                    return onDatesChange({ checkOutDate: format(date, 'yyyy-MM-dd') })
                                }}
                            />
                            <Input
                                type='time'
                                value={reservation.checkOutTime}
                                onChange={e => onDatesChange({ checkOutTime: e.target.value })}
                                className='w-24'
                            />
                        </div>
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}
